import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Button, InputAdornment, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import REST from "../../libs/API";
import PSIcon from "../../components/PSIcon";
import { CopyIcon, DeleteWallet } from "../../assets/images/icons";
import CClipboard from '../../components/CClipboard';
import TimerTile from './TimerTile';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { getText } from '../../libs/utils';
import CancelOrder from './CancelOrder';

const FormBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.only('md')]: {
    flexDirection: 'column'
  },
  [theme.breakpoints.only('xs')]: {
    flexDirection: 'column'
  },
  ".left-box": {
    flex: 1
  },
  ".right-box": {
    display: 'flex',
    flexDirection: 'column',
    gap: '19px',
    padding: '0 0 0 40px',
    [theme.breakpoints.only('md')]: {
      flexDirection: 'row',
      padding: '30px 0 0 0',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    [theme.breakpoints.only('xs')]: {
      padding: '30px 0 0 0',
    },
  },
}))

const PayByCoupon = ({ order, getStatus, handleTimeOut }) => {
  const fieldRefs = useRef({});
  const [fields, setFields] = useState({});

  useEffect(() => {
    order.code && REST.getPaymentForm(order.code).then((data) => {
      setFields(data);
    });
  }, []);

  const handleChange = (event) => {
    var newFields = fields.inputs;
    newFields[event.target.name * 1].value = event.target.value;
    setFields({ ...fields, inputs: newFields });
  }

  const handleBlur = (event) => {
    fieldRefs.current[event.target.name].validate(event.target.value);
  }

  const showDialog = () => {
    if (order?.toPaymentSystemType?.value == "BANK") {
      window.showModal({
        header: getText('dialKeepOrderHeader'),
        content: getText('dialKeepOrderText'),
        button: getText('dialKeepOrderButton'),
        onAccept: () => {
          handleSubmit();
        },
      });
    } else {
      handleSubmit();
    }
  }

  const handleSubmit = () => {
    var fieldsData = [];
    fields.inputs.map((field, i) => {
      fieldsData[`code[${i}]`] = field.value;
    });
    REST.sendPayment(order.code, fieldsData).then((data) => {
      if (!data.success) {
        window.showMessage(data.data[0].message);
      } else {
        getStatus();
      }
    });
  }

  const addRow = () => {
    if (fields.inputs?.length < 5) {
      var newFields = fields.inputs;
      newFields[newFields.length] = { ...newFields[0], value: '' };
      setFields({ ...fields, inputs: newFields });
    }
  }

  const removeRow = (key) => {
    var newFields = fields.inputs;
    newFields.splice(key, 1);
    setFields({ ...fields, inputs: newFields });
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h3">{getText('orderHeaderState9')}</Typography>
        <TimerTile timerEnd={order.endAt} handleTimeOut={handleTimeOut} />
      </Box>

      <Typography variant="regularCaption" component="div" sx={{ margin: '0 0 25px' }}>
        {getText('payCpnTopHint')}
      </Typography>

      <ValidatorForm
        onSubmit={showDialog}
        instantValidate={false}
      >
        <FormBox>
          <Box className='left-box'>
            {fields.inputs && fields.inputs.map((input, key) => (
              <TextValidator
                key={key}
                fullWidth
                validators={input.rules}
                errorMessages={input.messages}
                name={`${key}`}
                ref={el => fieldRefs.current[`${key}`] = el}
                onChange={handleChange}
                onBlur={handleBlur}
                value={input.value || ''}
                placeholder={input.label}
                variant="standard"
                InputProps={{
                  sx: { padding: '12px 10px 12px 21px !important' },
                  endAdornment: key > 0 &&
                    <InputAdornment
                      position="end"
                      onClick={() => removeRow(key)}
                      disabled={fields.length === 1}
                      sx={{ cursor: 'pointer' }}
                    >
                      <DeleteWallet width={42} height={42} />
                    </InputAdornment>
                }}
              />
            ))}
            <Box
              onClick={() => addRow()}
              sx={{ display: 'inline-block', margin: '5px 0 0' }}
            >
              <Typography sx={{ display: fields.inputs?.length >= 5 ? 'none' : 'block' }} variant="link">{getText('payCpnAddOne')}</Typography>
            </Box>
          </Box>

          <Box className='right-box'>
            <Box>
              <Box style={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant='orderHash' sx={{ fontSize: '32px' }}>
                  {order.amount?.value} {order.amount?.currencyCode}
                </Typography>
                <CClipboard text={order.amount?.value}>
                  <Box sx={{ margin: '4px 0 0 15px' }}><CopyIcon width="30" height="30" /></Box>
                </CClipboard>
              </Box>
              <Box style={{ display: 'flex', alignItems: 'center' }}>
                <PSIcon
                  name={order.fromPaymentSystemClassName}
                  height={24}
                  width={24}
                  margin="5px 10px 0 0"
                />
                <Typography variant='regularCaption'>{order.fromPaymentSystem}</Typography>
              </Box>
            </Box>

            <Button type="submit" variant="contained" sx={{ padding: '15px 31px', marginBottom: '-9px' }}>{getText('payCpnConfirm')}</Button>
            <CancelOrder size="large" orderCode={order.code} updateCallback={getStatus} />
          </Box>
        </FormBox>

      </ValidatorForm>
    </>
  )
}

export default PayByCoupon